import { LINKAREER_DOMAIN } from 'utils/config'

export const GSAT_REVIEW_PATHNAME = 'cbt-samsung'

export const TOPIC_ID = {
  GSAT: LINKAREER_DOMAIN === 'linkareer.com' ? '4185046' : '979159',
}

export const GSAT_REVIEW_SLUG_QUERY = {
  topicId: TOPIC_ID.GSAT,
}

export const SAMSUNG_INTERVIEW_BOARD_SLUG = 'samsung_interview'

// GSAT 응시후기 게시판 ID
// 환경변수로 관리하기엔 각 이벤트 서비스마다 게시판이 생성되어 변경될 수 있어 도메인을 통해 테스트서버, 상용서버 ID를 분리하여 설정합니다
export const GSAT_REVIEW_BOARD_ID =
  LINKAREER_DOMAIN === 'linkareer.com' ? '3738530' : '977524'

export const SAMSUNG_INTERVIEW_BOARD_ID =
  LINKAREER_DOMAIN === 'linkareer.com' ? '3519922' : '978654'
